$(document).ready(function() {
  $("body").on('click', '.mobile-menu-icon', function() {
       $('.mobile-megamenu').toggleClass('open-menu');
       setTimeout(function(){
         $('.mobile-header-sidebar').toggleClass('open-wrapper');
        }, 330);
       $('body').toggleClass('opened-drawer');
    $('html').toggleClass('opened-drawer');
       $('.overlay-content').toggleClass('open-overlay');
   });

   $(document).on('click', '.close-button', function() {
    $('.mobile-megamenu').removeClass('open-menu')
     $('.overlay-content').removeClass('open-overlay')
     $('body').removeClass('opened-drawer');
     $('html').removeClass('opened-drawer');

    setTimeout(function(){
    $('.mobile-megamenu-product').removeClass('show');
      $('.drawer-main').removeClass('main-submenu-open');
       $('.mobile-submenu-wrapper').removeClass('open-submenu-wrapper');
      $('.sublink-dropdown').removeClass('show');
    }, 1000);
    });

    $(document).mouseup(function (e) {
       var container = $('.mobile-megamenu');
       if (!container.is(e.target) && container.has(e.target).length === 0 && $('.mobile-megamenu').hasClass('open-menu')) {
       $('.mobile-megamenu').removeClass('open-menu')
       $('.overlay-content').removeClass('open-overlay')
       $('body').removeClass('opened-drawer');
         $('html').removeClass('opened-drawer');
       }
   });

    $(document).on('click','.back-section',function(event) {
      event.preventDefault();
      $('.dropdown-menus').removeClass('show');
      $('.drawer-main').removeClass('main-submenu-open');
       $('.sub-mobile-submenu-wrapper').removeClass('open-submenu-wrapper');
        $('.mobile-megamenu ').removeClass('mobile-megamenu-open');
     });

    $(document).on('click', '.drawer-main .accordion', function(event) {
        event.preventDefault();
        $('.mobile-megamenu ').addClass('mobile-megamenu-open');
        $('.mobile-header-menu-nav').addClass('submenu-open');
        $('.drawer-main').addClass('main-submenu-open');
        var $submenu = $(this).next();
        
        if ($submenu.hasClass('show')) {
            $submenu.removeClass('show');
            $submenu.find('.sub-mobile-submenu-wrapper').removeClass('open-submenu-wrapper');
        } else {
            $(this).parent().parent().find('.drawer-main .mobile-megamenu-product').removeClass('show');
            $submenu.addClass('show');
            setTimeout(function(){
               $submenu.find('.sub-mobile-submenu-wrapper').addClass('open-submenu-wrapper');
            }, 330);

        }
    });

    $(document).on('click','.drawer-main .accordion-menu',function(event) {
      event.preventDefault();
      $('.child-accordion-plus-icon').removeClass('is-open');
      if($(this).next().hasClass('show')) {
        $(this).next().removeClass('show');
        $(this).next().slideUp(350);
        $(this).removeClass('open-dropdwan');
        $(this).find('.child-accordion-plus-icon').removeClass('is-open');
      } else {
        $(this).parent().parent().find('li .dropdown-grandchild').removeClass('show');
        $(this).parent().parent().find('li .dropdown-grandchild').slideUp(350);
        $(this).next().toggleClass('show');
        $(this).next().slideToggle(350);
        $(this).addClass('open-dropdwan');
        $(this).find('.child-accordion-plus-icon').addClass('is-open');
      }
    });

});
